<template>
  <div class="recipe-drug-search">
    <fa-icon class="recipe-drug-search-icon" :icon="['fal', 'search']" />
    <dx-autocomplete
      id="find-drugs"
      v-model="drug"
      :source="findDrug"
      label="drug"
      track-by="drug-id"
      :debounce="800"
      placeholder="Pesquisar medicamento pelo nome comercial ou princípio ativo"
      @select="select"
    >
      <template v-slot="{ item }">
        <medicine-option v-if="item.id" :item="item" />
        <span v-else>
          <fa-icon class="text-success" :icon="['fal', 'plus']" />
          Adicionar: <strong class="text-primary">{{ item.name.toUpperCase() }}</strong>
        </span>
      </template>
    </dx-autocomplete>
  </div>
</template>

<script>
import MedicineOption from '@/components/medicine/MedicineOption.vue';

export default {
  components: {
    MedicineOption,
  },
  data() {
    return {
      drug: null,
    };
  },
  methods: {
    async findDrug(search) {
      const params = {
        search,
        groupBy: 'composition',
        limit: 100,
      };

      const items = await this.$httpX.get('/medicines', { params })
        .then(({ data }) => data.items);

      items.unshift({
        id: null,
        name: search,
      });

      return items;
    },
    select(item) {
      this.drug = null;
      this.$emit('select', item);
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/variables';
$recipe-drug-search-height: $control-size-lg + $unit-1;
$recipe-drug-search-padding-y: calc(($recipe-drug-search-height - $line-height) / 2)
  - $border-width-lg;

.recipe-drug-search {
  position: relative;
  .recipe-drug-search-icon {
    color: $primary-color;
    font-size: $font-size-lg;
    left: $control-padding-x-lg;
    pointer-events: none;
    position: absolute;
    top: calc($recipe-drug-search-height / 2);
    transform: translateY(-50%);
    z-index: 1;
  }
  .form-autocomplete .form-input {
    border-width: $border-width-lg;
    font-size: $font-size-lg;
    height: $recipe-drug-search-height;
    padding: $recipe-drug-search-padding-y $control-padding-x-lg;
    padding-left: $control-padding-x-lg + $font-size-lg + $layout-spacing;
  }
}
</style>
